import type * as React from "react";

/**
 * Form-level keydown guard: pressing Enter to choose an option in an open
 * picker (Radix Select listbox / option list) must not also submit the
 * enclosing form. Option-level handlers run before the event bubbles here,
 * so the selection itself still happens — only the stray submit default is
 * suppressed. The closed trigger (role="combobox") is deliberately NOT
 * matched: Enter there opens the picker and never submits.
 *
 * Attach as <form onKeyDown={preventPickerEnterSubmit}>.
 */
export function preventPickerEnterSubmit(event: React.KeyboardEvent<HTMLFormElement>) {
  if (event.key !== "Enter") return;
  const target = event.target as HTMLElement | null;
  if (target?.closest('[role="listbox"], [role="option"]')) {
    event.preventDefault();
  }
}
